export default __webpack_public_path__ + "static/media/ic_klp_40.c92f26bf.svg";